import React from "react";
import Header from "../shared/header";
import Footer from "../shared/footer";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";

const MainTag = styled("main")(({ theme }) => ({
  [theme.breakpoints.between("md", "lg")]: {
    paddingTop: "60px !important",
  },
  [theme.breakpoints.up("lg")]: {
    paddingTop: "60px !important",
  },
  [theme.breakpoints.down("sm")]: {
    paddingTop: "100px !important",
  },
  [theme.breakpoints.down("md")]: {
    paddingTop: "60px !important",
  },
}));

const MainLayout = (props) => {
  const location = useLocation();
  const IsHomePage = location.pathname === "/" ? true : false;
  return (
    <>
      <Header />
      <MainTag className="MainTag">{props.children}</MainTag>
      {IsHomePage ? <Footer /> : null}
    </>
  );
};

export default MainLayout;
